import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAIL,
  FETCH_USERS_BY_USERNAME,
  FETCH_USERS_BY_USERNAME_FAIL,
  FETCH_USERS_BY_USERNAME_SUCCESS,
  RESET_USER_DATA,
  CHANGE_ADMIN_ROLE,
  CHANGE_ADMIN_ROLE_SUCCESS,
  CHANGE_ADMIN_ROLE_FAILS,
} from './CreateAdminActionType';

const initialState = {
  fetching: false,

  users: {
    error: { status: false, message: '' },
    success: false,
    list: [],
  },

  assignAdminData: {
    error: { status: false, message: '' },
    success: false,
    payload: {},
  },

  userData: {
    error: { status: false, message: '' },
    success: false,
    data: {},
  },
};

export const CreateAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_ADMIN_ROLE:
      return {
        ...state,
        fetching: true,
        assignAdminData: {
          ...state.assignAdminData,
          fetching: true,
          error: { status: false, message: '' },
          success: false,
        },
      };

    case CHANGE_ADMIN_ROLE_SUCCESS:
      return {
        ...state,
        fetching: false,
        assignAdminData: {
          ...state.assignAdminData,

          error: { status: false, message: '' },
          success: true,
        },
      };

    case CHANGE_ADMIN_ROLE_FAILS:
      return {
        ...state,
        fetching: false,
        assignAdminData: {
          ...state.assignAdminData,
          error: { status: true, message: action.payload },
          success: false,
        },
      };

    case FETCH_ALL_USERS:
      return {
        ...state,
        fetching: true,
        users: {
          ...state.users,

          error: { status: false, message: '' },
        },
      };

    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        users: {
          ...state.users,

          list: action.payload,
          error: { status: false, message: '' },
        },
      };

    case FETCH_ALL_USERS_FAIL:
      return {
        ...state,
        fetching: false,
        users: {
          ...state.users,

          error: { status: true, message: action.payload },
        },
      };
    case FETCH_USERS_BY_USERNAME:
      return {
        ...state,
        fetching: true,
        userData: {
          ...state.userData,
          error: { status: false, message: '' },
        },
      };

    case FETCH_USERS_BY_USERNAME_SUCCESS:
      return {
        ...state,
        fetching: false,
        userData: {
          ...state.userData,
          data: action.payload,
          error: { status: false, message: '' },
        },
      };

    case FETCH_USERS_BY_USERNAME_FAIL:
      return {
        ...state,
        fetching: false,
        userData: {
          ...state.userData,
          error: { status: true, message: action.payload },
        },
      };
    case RESET_USER_DATA:
      return {
        ...state,
        userData: {},
      };

    default:
      return state;
  }
};
